export const contactTextValues = {
    contact: {
        type: 'contact',
        title: 'Contact',
        text:
            'Heb je vragen over NXT? Neem dan contact met ons op door onderstaand formulier in te vullen. Je ontvangt een reactie van ons.',
    },
    internship: {
        type: 'internship',
        title: 'Contact stage',
        text:
            'Heb je algemene vragen over ons stagebeleid? Vul dan dit contactformulier in t.a.v. S. Verhoeven | Coördinator P&O. Dit formulier is niet bedoeld om een stageplaats te vinden; dat gaat alleen via de school zelf (zie contactpersonen per ORION-school).',
    },
};
